import React, { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import FileUpload from '../components/FileUpload';
import FileList from '../components/FileList';
import EntitlementUpload from '../components/EntitlementUpload';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`upload-tabpanel-${index}`} aria-labelledby={`upload-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const UploadPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      {/* Header */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <CloudUploadIcon sx={{ fontSize: 32, color: 'primary.main' }} />
          <Typography variant="h4" component="h1">
            Upload de Arquivos
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Faça upload de títulos e concessões para o sistema Reedy.
        </Typography>
      </Paper>

      {/* Tabs */}
      <Paper sx={{ width: '100%' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="upload tabs">
          <Tab label="Upload de Título" />
          <Tab label="Upload de Concessão" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <FileUpload />
          <FileList />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <EntitlementUpload />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default UploadPage;
